import OspreyTemplatesGetById from './templates-get-by-id'
import OspreyTemplatesGetThumbnails from './templates-get-thumbnails'
import OsperyTemplatesMetadata from './templates-metadata'
import OspreyTemplatesSearch from './templates-search'
import OspreyTemplatesSearchSuggestion from './templates-search-suggestion'
import OspreyTemplatesTagsApply from './templates-tags-apply'
import OspreyTemplatesTagsRemove from './templates-tags-remove'
import OspreyTemplatesShareToSilos from './templates-silos-share'
import OspreyTemplatesRemoveFromSilosShare from './templates-silos-remove'
import OspreyTemplatesShareToAffiliations from './templates-affiliations-share'
import OspreyTemplatesRemoveFromAffiliationsShare from './templates-affiliations-remove'
import OspreyTemplatesUpdate from './templates-update'
import OspreyTemplatesCreate from './templates-create'
import OspreyTemplatesPreview from './templates-preview'
import OspreyTemplateMessagePreview from './template-message-preview'
import OspreyTemplatesUnShareArchive from './templates-unShare-archive'

export default class Templates {

    create(...args) {
        return new OspreyTemplatesCreate(...args)
    }

    update(...args) {
        return new OspreyTemplatesUpdate(...args)
    }

    preview(...args) {
        return new OspreyTemplatesPreview(...args)
    }

    search(...args) {
        return new OspreyTemplatesSearch(...args)
    }

    getSearchSuggestion(...args) {
        return new OspreyTemplatesSearchSuggestion(...args)
    }

    getMetadata() {
        return new OsperyTemplatesMetadata()
    }

    getById(...args) {
        return new OspreyTemplatesGetById(...args)
    }

    getThumbnails(...args) {
        return new OspreyTemplatesGetThumbnails(...args)
    }

    applyTagToTemplate(...args) {
        return new OspreyTemplatesTagsApply(...args)
    }

    removeTagFromTemplate(...args) {
        return new OspreyTemplatesTagsRemove(...args)
    }

    shareToSilos(...args) {
        return new OspreyTemplatesShareToSilos(...args)
    }

    removeFromSilosShare(...args) {
        return new OspreyTemplatesRemoveFromSilosShare(...args)
    }

    shareToAffiliations(...args) {
        return new OspreyTemplatesShareToAffiliations(...args)
    }

    removeFromAffiliationsShare(...args) {
        return new OspreyTemplatesRemoveFromAffiliationsShare(...args)
    }

    messagePreview(...args) {
        return new OspreyTemplateMessagePreview(...args)
    }

    unShareArchiveTemplate(...args) {
        return new OspreyTemplatesUnShareArchive(...args)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/index.js